<template>
  <main>
    <div class="breadcrumb">
      <div class="container">
        <ul>
          <li><router-link to="/">HARUMIFLAG</router-link></li>
          <li><router-link to="/infomation">インフォメーション一覧</router-link></li>
          <li><router-link to="/infomation/not_found">お知らせのない時</router-link></li>
        </ul>
      </div>
    </div>
    <div class="info-list">
      <div class="info-cont">
        <h2>INFORMATION<span>インフォメーション一覧</span></h2>
        <div class="info-cont__list">
          <div class="container">
            <div class="container-child">
              <p class="text-not_found">現在、お知らせはありません。</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { RouterLink } from 'vue-router';

export default {
  name: 'InformationNotFound',
  components: {
  }
}
</script>
